import {
  AzureOfferPlan,
  AzurePricingType,
} from '../../../modules/privateOffer/types'
import { useStyles } from './PlanBasicDetail.styles'
import { useStyles as usePricingStyles } from '../MicrosoftViewPricing.styles'
import {
  DetailInfo,
  DetailRow,
} from '../../../common/components/DetailRow/DetailRow'
import { Truncate } from '@labrav/react-components'
import { isNonEmptyNumber } from '@labrav/common'
import { isContainerDiscountPricingType } from '@labrav/marketplace'

interface PlanBasicDetailProps {
  plan: AzureOfferPlan
  index: number
  azurePricingType?: AzurePricingType
  hideDiscount?: boolean
}

export const PlanBasicDetail = ({
  plan,
  index,
  azurePricingType,
  hideDiscount = false,
}: PlanBasicDetailProps) => {
  const { classes } = useStyles()
  const { classes: pricingClasses } = usePricingStyles()
  const isDicounted =
    !hideDiscount &&
    isNonEmptyNumber(plan.discountPercentage) &&
    isContainerDiscountPricingType(azurePricingType)
  return (
    <div className={classes.container}>
      <div className={pricingClasses.subHeading}>Plan {index + 1}</div>
      <DetailRow className={classes.planDetailRow} props={{ spacing: 4 }}>
        <>
          <DetailInfo
            title="Name"
            value={
              <Truncate width={'100%'} clipboardTooltip showIcon={false}>
                {plan.displayName}
              </Truncate>
            }
            keyName="displayName"
            gridSize={4}
          />
          <DetailInfo
            title="Description"
            value={
              <Truncate width={'100%'} clipboardTooltip showIcon={false}>
                {plan.description}
              </Truncate>
            }
            keyName="description"
            gridSize={isDicounted ? 6 : 8}
          />
          {isDicounted && (
            <DetailInfo
              title="Discount(%)"
              value={`${plan.discountPercentage}`}
              keyName="discountPercentage"
              gridSize={2}
              align="end"
            />
          )}
        </>
      </DetailRow>
    </div>
  )
}
